fx.ns("models", class ProductPoster extends  models.Creation {

	constructor(data)
	{
		super(data);

        this.product_type_id = models.ProductType.POSTER;
	}
	
    get posterPage()
    {
        return this.elements.getItemAt(0);
    }

    get totalPrice()
    {
		return (this.creationOption.price_base * fx.get("lang").tax).toFixed(2) + " €" ; 
    }

    get pageWidth()
    {
        // poster orientation is a per-creation choice (shape_option), not a format attribute (all formats are "portrait")
        return this.shape_option == "landscape" ? 300 : 210; // portrait / undefined => 210
    }

    get pageHeight()
    {
        return this.shape_option == "landscape" ? 210 : 300; // portrait / undefined => 300
    }

    get format()
    {
        return this.creationOption.format;
    }

    get option()
    {
        return this.creationOption.option;
    }

    /*get creationOption()
    {
        return this.creationOptions ? this.creationOptions.find({formatid : this.formatid, option_id : this.optionid}) : null;
    }*/

    get creationOption()
    {
        if (this.creationOptions)
            return this.creationOptions.find({formatid : this.formatid, option_id : this.optionid})
        else
            return this._creationOption;
    }

    set creationOption(val)
    {
        this._creationOption = val;
    }

    get creationOptions()
    {
        return this._creationOptions;
    }

    set creationOptions(val)
    {
        this._creationOptions = val;
    }

    // the server sends the poster formats of both orientations : a portrait poster
    // is only offered portrait sizes, a landscape one landscape sizes
    inOrientation(creationOption)
    {
        let current = this.creationOption;
        let style = current && current.format ? current.format.style : null;

        return !style || !creationOption.format || creationOption.format.style == style;
    }

    // the cover thumbnail shows the size and the finish (the frame is drawn in it) : a change of
    // either is a cover to draw again on the next save, as an edit of the page would be
    _coverOutdated(before)
    {
        if (this.formatid + "/" + this.optionid != before && this.cover)
            this.cover.modified = true;
    }

    updateFormat(id)
    {
        let before = this.formatid + "/" + this.optionid;
        let exist = false;
        for(let i = 0; i < this.creationOptions.length; i++)
        {
            let creationOption = this.creationOptions.getItemAt(i);
            if (creationOption.option.id == this.optionid && creationOption.formatid == id)
            {
                exist = true;
                break;
            }
        }

        if (exist)
            this.formatid = id;
        else
        {
            let nearest;
            for(let i = 0; i < this.creationOptions.length; i++)
            {
                let creationOption = this.creationOptions.getItemAt(i);
                if (creationOption.option.id == this.optionid && this.inOrientation(creationOption))
                    nearest = creationOption;
            }

            if (nearest)
                this.formatid = nearest.formatid;
        }

        this._coverOutdated(before);
    }

    updateOption(id)
    {
        let before = this.formatid + "/" + this.optionid;
        let exist = false;
        for(let i = 0; i < this.creationOptions.length; i++)
        {
            let creationOption = this.creationOptions.getItemAt(i);
            if (creationOption.option.id == id && creationOption.formatid == this.formatid)
            {
                exist = true;
                break;
            }
        }

        if (exist)
            this.optionid = id;
        else
        {
            let nearest;
            for(let i = 0; i < this.creationOptions.length; i++)
            {
                let creationOption = this.creationOptions.getItemAt(i);
                if (creationOption.formatid == this.formatid)
                    nearest = creationOption;
            }

            if (nearest)
                this.optionid = nearest.option_id;
        }

        this._coverOutdated(before);
    }

    optionForType(type, nearest, cheapest)
    {
        this.creationOptions.sort( (a, b) => a.price_base - b.price_base);

        for(let i = 0; i < this.creationOptions.length; i++)
        {
            let creationOption = this.creationOptions.getItemAt(i);
            if (creationOption.option.editor_code == type && this.inOrientation(creationOption) && ((nearest || cheapest) || creationOption.formatid == this.formatid))
                return creationOption;
        }

        return null;
    }

    get borderAsset()
    {
        return fx.assets["frame" + this.option.editor_code.capitalize() + this.format.size.capitalize()];
    }

    get borderSize()
    {
        let borderSize;
        switch(this.format.size)
        {
            case "small":
                borderSize = 14;
                break;
            case "medium":
                borderSize = 11;
                break;
            case "big":
                borderSize = 9;
                break;
        }
        return borderSize;
    }  

    get filteredPhoto()
    {
        //return this.posterPage.getPhotos().find({content_type : "remove-background"});
        let photos = this.posterPage.getPhotos();

        for(let i = 0; i < photos.length; i++)
        {
            let photo = photos.getItemAt(i);
            if (photo.content_type != "")
                return photo;
        }
    }

    calculatePrice()
	{
        return this.totalPrice + " €" ;
	}

    addPoster()
    {
        let newElement = new models.ProductPosterPage({creation_id : this.id, layoutid : 0});
			
		this.elements.addItem( newElement );

		newElement.addBackground();

        return newElement;
    }

    addPhotosForCreation()
    {
        if (!this.started && this.photosForCreations.length == 1 && this.posterPage.photosComponents.length >= 1)
            this.posterPage.photosComponents.getItemAt(0).content = this.photosForCreations.getItemAt(0);
    }
});
